import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useQueryEditor } from "../query-editor.js";
/* empty css                      */
/* empty css                */
/* empty css                */
/* empty css                */
/* empty css                */
/* empty css                */
/* empty css                          */
/* empty css                  */
const QueryEditor = (props) => {
  const $ = c(2);
  const ref = useQueryEditor(props, QueryEditor);
  let t0;
  if ($[0] !== ref) {
    t0 = /* @__PURE__ */ jsx("div", { className: "graphiql-editor", ref });
    $[0] = ref;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export {
  QueryEditor
};
//# sourceMappingURL=query-editor.js.map
